var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftdetail"
  }, [_c('div', {
    staticClass: "nftdetail-bg",
    style: {
      background: `url(${require('@images/tapcoin/task-detail-bg.jpg')}) center top/100% auto no-repeat`
    }
  }), _vm.detail ? _c('div', {
    staticClass: "nftdetail-main"
  }, [_c('div', {
    staticClass: "nftdetail__title"
  }, [_vm._v(_vm._s(_vm.detail.type == "compose" ? _vm.animateEle ? _vm.detail.name : "" : _vm.detail.name))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detail.type == 'compose' ? _vm.isNftUrlLLoad : true,
      expression: "detail.type == 'compose' ? isNftUrlLLoad : true"
    }],
    key: _vm.detail?.image_url,
    staticClass: "popNftDetail",
    class: {
      'animate-start': _vm.detail.type == 'compose' ? _vm.animateStart : false,
      imgResult: _vm.animateEle
    }
  }, [_c('div', {
    ref: "imgRef",
    staticClass: "popNftDetail-img",
    class: _vm.detail.type == 'compose' && 'initAnim'
  }, [_c('div', {
    staticClass: "popNftDetail-img-bg",
    style: {
      background: `url(${require(`@images/tapcoin/new/fortune/fortune-card-${_vm.detail.attributes.Bg.value.replace(/\s*/g, '')}.png`)}) center top/100% auto`
    }
  }), _c('div', {
    staticClass: "popNftDetail-img-main"
  }, [_vm.detail?.image_url ? _c('img', {
    attrs: {
      "src": _vm.detail.image_url,
      "alt": ""
    },
    on: {
      "load": _vm.onImageLoad,
      "error": _vm.onImageError
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "popNftDetail-score"
  }, [_c('div', {
    staticClass: "popNftDetail-score-value"
  }, [_vm._v("Rarity Score: " + _vm._s(_vm._f("fmt_pre")(_vm.detail.rarity_score)))]), _c('div', {
    staticClass: "popNftDetail-score-star"
  }, _vm._l(Array(_vm.detail.star), function (_) {
    return _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/fortune/forturn-star.png`),
        "alt": ""
      }
    });
  }), 0)]), _vm.detail.is_use ? _c('div', {
    staticClass: "popNftDetail-tag",
    style: {
      background: `url(${require('@images/tapcoin/new/fortune/forturn-tag.png')}) center top/100% auto`
    }
  }) : _vm._e()]), _vm.detail.type != 'compose' || _vm.detail.type == 'compose' && _vm.animateEle ? _c('div', {
    staticClass: "btn-mint"
  }, [_vm._v("Mint")]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fadeele-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detail.type == 'compose' ? _vm.showEle : true,
      expression: "detail.type == 'compose' ? showEle : true"
    }],
    staticClass: "popNftDetail-ele",
    class: [_vm.detail.type == 'compose' && 'initAnim', {
      'animate-ele': _vm.detail.type == 'compose' ? _vm.animateEle : false
    }]
  }, [_c('div', {
    staticClass: "popNftDetail-ele-main"
  }, _vm._l(_vm.detail.attributes, function (val, key, index) {
    return _c('div', {
      key: index,
      staticClass: "popNftDetail-ele-item",
      class: _vm.detail.type == 'compose' && 'initAnim',
      style: {
        transitionDelay: _vm.animateEle ? `${index * 0.1}s` : '0s'
      }
    }, [_c('div', {
      staticClass: "popNftDetail-ele-item__attr"
    }, [_vm._v(" " + _vm._s(key) + ":  " + _vm._s(val.value) + " ")]), _c('div', {
      staticClass: "popNftDetail-ele-item__rarity"
    }, [_vm._v(_vm._s(val.rarity) + "%")])]);
  }), 0)])])], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };